import decimal from './decimal.js';
import notify from "@zh-or/lib/notify";

let scriptLoaded = {};
let scriptLoadWaitKey = 'awldfpo2t3tr92c23ir1lkeawdadhjj65tkxcvl' + Date.now();
let loading;

export default {
    goErrPage(msg) {
        document.body.innerHTML = `
        <center>
            <pre style="font-size: 18px;color: #ff3f46;">${msg}</pre>
        </center>
        `;
    },
    getXXPhone(raw) {
        if(raw && raw.length >= 11) {
            return raw.substring(0, 3) + '****' + raw.substring(8, 11);
        }
        return raw;
    },
    getQueryString(name, str) {
        var result = (str || location.href).match(new RegExp("[\?\&]" + name + "=([^\&\#]+)", "i"));
        if (result == null || result.length < 1) {
            return "";
        }
        return decodeURIComponent(result[1]);
    },
    isWeChat() {
        return !!window.navigator.userAgent.match(/MicroMessenger/gi);
    },
    isWorkWeChat() {
        return !!window.navigator.userAgent.match(/wxwork/i);
    },

    async sleep(t) {
        return new Promise((resolve, reject) => {
            setTimeout(_ => {
                resolve();
            }, t);
        })
    },
    toFixed(num, f) {//四舍五入
        return new decimal(num).toFixed(f || 2, decimal.ROUND_DOWN);
    },
    toFixedUP(num, f) {//四舍五入
        return new decimal(num).toFixed(f || 2, decimal.ROUND_UP);
    },
    getDecima() {
        return decimal;
    },
    Number(v, def) {
        try {
            let r = Number(v);
            if(!isNaN(v)) {
                return r;
            }
            if(def) {
                return def;
            }
        } catch(e) {
            console.error('format number error: ', e, v, def);
        }
        return 0;
    },
    formatMoney(p, fix) {
        if(typeof fix != 'undefined') {
            fix = Number(fix);
            fix = isNaN(fix) ? 0 : fix;
        } else {
            fix = 2;
        }

        let p2 = this.Number(p);
        p2 = p2.toFixed(fix);
        return p2;
    },
    calc(a, m, b) {
        let da = new decimal(a);
        let db = new decimal(b);
        let r = '0';
        switch(m) {
            case '+': r = da.add(db); break;
            case '-': r = da.sub(db); break;
            case '*': r = da.mul(db); break;
            case '/': r = da.div(db); break;
            case '%': r = da.mod(db); break;
            default:
                r = new decimal(0);
        }

        r = r.toNumber();
        r = isNaN(r) ? 0 : r;

        //console.log(`calc: ${a} ${m} ${b} = ${r}`);
        return r;
    },
    calcEx() {
        let params = [...arguments];
        let res = null, m = null;
        params.forEach(v => {
            if(res === null) res = v;
            else if(m === null) m = v;
            else {
                res = this.calc(res, m, v);
                m = null;
            }
        });
        return res;
    },

    objToQueryString(obj) {
        let res = [];
        Object.keys(obj).forEach(k => {
            res.push(k + '=' + encodeURIComponent(obj[k]));
        });
        return res.join('&');
    },
    makeService(url, service, req) {
        let keys = Object.keys(url);

        keys.forEach(k => {
            if (!service.hasOwnProperty(k)) {
                service[k] = function (data) {

                    let val = url[k];
                    let tmp = val.split('|');

                    if (!tmp || tmp.length != 2) {
                        throw new Error(url + ' 中没有分隔符 | , 格式必须为 method|path');
                    }

                    let m = tmp[0].toUpperCase();
                    let path = tmp[1];

                    if(!path) {
                        path = m;
                    }

                    //url/{params}
                    if(path.indexOf('{') && data) {
                        Object.keys(data).forEach(k => {
                            path = path.replace(`{${k}}`, data[k]);
                        })
                    }

                    if (m == 'GET') {
                        return req.get(path, data);
                    } else if (m == 'POST') {
                        return req.post(path, data);
                    } else if (m == 'FORMDATA') {
                        return req.formData(path, data);
                    } else if (m == 'PATCH') {
                        return req.patch(path, data);
                    } else if (m == 'DELETE') {
                        return req.delete(path, data);
                    } else {
                        console.log(path + '\n暂不支持:' + m + ', 其他方法请自定义');
                    }
                    return Promise.reject('不支持的请求方式');
                };

            }
        });

    },
    loadScript(src) {
        return new Promise((resolve, reject) => {
            if(scriptLoaded.hasOwnProperty(src) && scriptLoaded[src] === 1) {
                resolve();
                return;
            }
            if(scriptLoaded[src] === 0) {
                notify.lock(scriptLoadWaitKey).wait()
                    .then(resolve)
                    .catch(reject);
                return;
            }
            scriptLoaded[src] = 0;
            let script = document.createElement('script');
            script.type = 'text/javascript';
            // IE
            if (script.readyState) {
                script.onreadystatechange = function() {
                    if (script.readyState == 'loaded' || script.readyState == 'complete') {
                        script.onreadystatechange = null;
                        scriptLoaded[src] = 1;
                        resolve();
                        notify.notify(scriptLoadWaitKey);
                    }
                };
            } else {
                // 其他浏览器
                script.onload = function() {
                    scriptLoaded[src] = 1;
                    resolve();
                    notify.notify(scriptLoadWaitKey);
                };
            }
            script.onerror = function(e) {
                reject(e);
                delete scriptLoaded[src];
                notify.notifyError(scriptLoadWaitKey);
            }
            script.src = src;
            document.body.appendChild(script);
        })
    },
}
